/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M12.4656 13.4822a6.0286 6.0286 0 0 0 .2844-.0286c2.714-.3385 4.8651-2.4896 5.2036-5.2036A6.0398 6.0398 0 0 0 18 7.5c0-3.3137-2.6863-6-6-6s-6 2.6863-6 6c0 .067.0011.1337.0033.2002.1038 3.168 2.6635 5.7147 5.8367 5.7977a6.08 6.08 0 0 0 .6256-.0157Zm.0689-1.5136A.7517.7517 0 0 0 12.75 12c2.0711 0 3.75-1.6789 3.75-3.75a.7513.7513 0 0 0-.0314-.2155A.75.75 0 0 0 15 8.25c0 1.2426-1.0074 2.25-2.25 2.25a.75.75 0 0 0-.2155 1.4686ZM13.5 14.85A7.5333 7.5333 0 0 1 12 15a7.5333 7.5333 0 0 1-1.5-.15 7.4424 7.4424 0 0 1-1.5-.4741V18.75a.75.75 0 0 0 .75.75h4.5a.75.75 0 0 0 .75-.75v-4.3741a7.443 7.443 0 0 1-1.5.4741Zm3-1.3495c1.8217-1.3683 3-3.5468 3-6.0005C19.5 3.3579 16.1421 0 12 0S4.5 3.3579 4.5 7.5c0 2.33 1.0625 4.4118 2.7293 5.7874.0885.073.1788.1441.2707.2131V18.75C7.5 19.9926 8.5074 21 9.75 21v.75C9.75 22.9926 10.7574 24 12 24s2.25-1.0074 2.25-2.25V21c1.2426 0 2.25-1.0074 2.25-2.25v-5.2495ZM11.25 21.75a.75.75 0 0 0 1.5 0V21h-1.5v.75Z"
    clipRule="evenodd"
  />,
  'Bulb'
);
